<template>

    <KedvezmenyekBase>

        <v-layout slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="motorVisible()" :attributes="motor" />

            <BnFormField v-if="partnerPortalVisible()" :attributes="khugyfelportal" />

<!--            <BnFormField v-if="homeOfficeVisible()" :attributes="homeoffice" />-->

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import { MOTOR } from '../../../../../../../modules/Gepjarmu';
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';

export default {
    name: 'KedvezmenyekB10',
    components: { BnFormField, KedvezmenyekBase },
    mixins: [Kedvezmeny],
    methods: {
        partnerPortalVisible() {
            return this.$store.getters.tarifaData.egfb_regisztracio
                && this.$store.getters.tarifaData.allianztelefon
                && this.$store.getters.tarifaData.ajanl_fizmod_type !== 1
                && this.$store.getters.tarifaData.allianzemail;
        },
        motorVisible() {
            return this.getValue('gepjarmu.fajta') === MOTOR;
        },
    },
    data() {
        return {
            motor: {
                type: 'checkbox',
                label: 'Chopper, cruiser és túramotor kedvezmény',
                visible: true,
                editable: !this.disabled,
                mezo: 'kh_motor',
                path: 'kedvezmenyekbiztosito.10.motor',
                help: true,
                change: this.shouldRecalc,
            },
            khugyfelportal: {
                type: 'checkbox',
                label: 'Ügyfélportál regisztráció',
                visible: true,
                editable: !this.disabled,
                mezo: 'kh_khugyfelportal',
                path: 'kedvezmenyekbiztosito.10.khugyfelportal',
                help: true,
                change: this.shouldRecalc,
            },
            homeoffice: {
                label: 'Home office kedvezmény',
                type: 'checkbox',
                visible: true,
                editable: !this.disabled,
                rules: [],
                path: 'kedvezmenyekbiztosito.10.homeoffice',
                mezo: 'kh_homeoffice',
                change: this.shouldRecalc,
                help: true,
            },
        };
    },
};
</script>
